// extracted by mini-css-extract-plugin
module.exports = {"HomePageSection":"CatalogHome_HomePageSection___uAgm","topPadding":"CatalogHome_topPadding__kx2I7"};